(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-featured-buy"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGallery(gallery) {
      if (gallery.dataset.rfGalleryInit === 'true') return;
      gallery.dataset.rfGalleryInit = 'true';

      var track = gallery.querySelector('[data-rf-gallery-track]');
      var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-rf-gallery-slide]'));
      var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-rf-gallery-dot]'));
      var prevBtn = gallery.querySelector('[data-rf-gallery-prev]');
      var nextBtn = gallery.querySelector('[data-rf-gallery-next]');
      if (!track || slides.length < 2) return;

      function currentIndex() {
        var scrollLeft = track.scrollLeft;
        var width = track.clientWidth || 1;
        return Math.round(scrollLeft / width);
      }

      function goTo(index) {
        var clamped = Math.max(0, Math.min(slides.length - 1, index));
        var target = slides[clamped];
        if (target) {
          track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        }
        updateDots(clamped);
      }

      function updateDots(index) {
        dots.forEach(function (dot, i) {
          dot.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          goTo(currentIndex() - 1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          goTo(currentIndex() + 1);
        });
      }
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          goTo(i);
        });
      });

      var scrollTimeout;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function () {
          updateDots(currentIndex());
        }, 100);
      });
    }

    function initAll() {
      document.querySelectorAll('[data-rf-gallery]').forEach(initGallery);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-quote-band"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initQuoteBand(el) {
      if (el.dataset.rfQuoteInit === 'true') return;
      el.dataset.rfQuoteInit = 'true';

      var slides = Array.prototype.slice.call(el.querySelectorAll('[data-rf-quote-slide]'));
      var prevBtn = el.querySelector('[data-rf-quote-prev]');
      var nextBtn = el.querySelector('[data-rf-quote-next]');
      if (slides.length < 2) return;

      var index = 0;
      slides.forEach(function (slide, i) {
        if (slide.getAttribute('aria-current') === 'true') index = i;
      });

      function show(newIndex) {
        index = (newIndex + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          slide.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { show(index - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { show(index + 1); });
    }

    function initAll() {
      document.querySelectorAll('[data-rf-quote-band]').forEach(initQuoteBand);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
